// const BASE_URI_PHP = "http://aamirabbas-pc:8080/electoralroll/api";
const BASE_URI_PHP = "https://electoral.kpsiaj.org/api";
const BASE_URI_NODEJS = "https://nodejsbackend-xi.vercel.app/api";

export { BASE_URI_PHP, BASE_URI_NODEJS };
